import { useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import { useSingleton } from '@bydesign-ui/hooks';
import { equal } from '@bydesign-ui/utils';
export function RcPortal(props) {
  var children = props.children,
      getContainer = props.getContainer,
      onUpdated = props.onUpdated;
  var prevParent = useRef(null);
  var container = useSingleton(function () {
    return document.createElement('div');
  });
  var parent = getContainer == null ? document.body : getContainer();
  var isEqual = equal(prevParent.current, parent);
  prevParent.current = parent;

  if (!isEqual && parent) {
    parent.appendChild(container);
  }

  useEffect(function () {
    return function () {
      if (container.parentNode) {
        container.parentNode.removeChild(container);
      }
    };
  }, []);
  useEffect(function () {
    if (parent && onUpdated) {
      onUpdated();
    }
  });

  if (parent) {
    return ReactDOM.createPortal(children, container);
  }

  return null;
}